(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const	productForm = document.querySelector('.product-form'),
			productDetails = document.querySelector('.product-header'),
			floatingCta = document.querySelector('.floating-product-cta'),
			expandToggle = document.querySelector('.expand-toggle'),
			extraDescription = document.querySelector('.product-description-extra'),
			siteFooter = document.querySelector('.site-footer');
    

	document.querySelectorAll('.product-description-extra.expandable').forEach(wrapper => {
		const btn = wrapper.querySelector('.expand-toggle');
		const content = wrapper.querySelector('.product-description-extra-content');
		if (!btn || !content) return;
		const more = btn.getAttribute('data-expanded-toggle-more');
		const less = btn.getAttribute('data-expanded-toggle-less');
		let expanded = false;
		btn.addEventListener('click', () => {
			expanded = !expanded;
			wrapper.classList.toggle('expanded', expanded);
			btn.textContent = expanded ? less : more;
		});
	});

    // Handle option selection for variants
    function handleOptionSelection() {
        const optionSelectors = document.querySelectorAll('.option-selector');
        const hiddenVariantInput = document.getElementById('selected-variant-id');
        const formVariantInput = document.querySelector('.product-form input[name="id"]');
        
        if (!optionSelectors.length || !hiddenVariantInput || !formVariantInput) return;
        
        optionSelectors.forEach(selector => {
            selector.addEventListener('change', function() {
                // Get all selected options
                const selectedOptions = [];
                const optionGroups = document.querySelectorAll('.option-group');
                
                optionGroups.forEach(group => {
                    const selectedOption = group.querySelector('.option-selector:checked');
                    if (selectedOption) {
                        selectedOptions.push(selectedOption.dataset.value);
                    }
                });
                
                // Find matching variant
                const matchingVariant = productData.variants.find(variant => {
                    return variant.options.every((option, index) => option === selectedOptions[index]);
                });
                
                if (matchingVariant) {
                    // Update hidden inputs
                    hiddenVariantInput.value = matchingVariant.id;
                    formVariantInput.value = matchingVariant.id;
                    
                    // Update price display
                    const priceElement = document.getElementById('product-price');
                    if (priceElement) {
                        priceElement.textContent = formatMoney(matchingVariant.price);
                    }
                    
                    // Update compare at price
                    const compareAtPriceElement = document.querySelector('.product-price-before');
                    if (compareAtPriceElement) {
                        if (matchingVariant.compare_at_price > matchingVariant.price) {
                            compareAtPriceElement.textContent = `${translations.before} ${formatMoney(matchingVariant.compare_at_price)}`;
                            compareAtPriceElement.classList.remove('d-none');
                        } else {
                            compareAtPriceElement.classList.add('d-none');
                        }
                    }
                    
                    // Update save percentage
                    const savePercentElement = document.querySelector('.product-price-save');
                    if (savePercentElement) {
                        if (matchingVariant.compare_at_price > matchingVariant.price) {
                            const priceDifference = matchingVariant.compare_at_price - matchingVariant.price;
                            const savePercent = Math.round((priceDifference / matchingVariant.compare_at_price) * 100);
                            savePercentElement.textContent = `${translations.save} ${savePercent}%`;
                            savePercentElement.classList.remove('d-none');
                        } else {
                            savePercentElement.classList.add('d-none');
                        }
                    }
                    
                    // Update stock status
                    const stockStatus = document.querySelector('.product-stock');
                    if (stockStatus) {
                        const stockSpan = stockStatus.querySelector('span');
                        if (stockSpan) {
                            if (matchingVariant.available) {
                                stockSpan.textContent = stockSpan.textContent.includes(translations.inStock.toLowerCase()) ? stockSpan.textContent : translations.inStock;
                                stockSpan.className = 'in-stock';
                            } else {
                                stockSpan.textContent = stockSpan.textContent.includes(translations.outOfStock.toLowerCase()) ? stockSpan.textContent : translations.outOfStock;
                                stockSpan.className = 'out-of-stock';
                            }
                        }
                    }
                    
                    // Update add to cart button
                    const addToCartBtns = document.querySelectorAll('.add-to-cart');
                    addToCartBtns.forEach(btn => {
                        if (matchingVariant.available) {
                            btn.disabled = false;
                            btn.textContent = btn.textContent.includes(translations.addToCart.slice(0, 6)) ? btn.textContent : translations.addToCart;
                        } else {
                            btn.disabled = true;
                            btn.textContent = translations.outOfStock;
                        }
                    });
                    
                    // Update main product image if variant has featured image
                    const mainImage = document.getElementById('main-product-image');
                    if (mainImage && matchingVariant.featured_image) {
                        // Handle both string URLs and image objects
                        let imageUrl = '';
                        if (typeof matchingVariant.featured_image === 'string') {
                            imageUrl = matchingVariant.featured_image.replace('200x200', '800x800');
                        } else if (matchingVariant.featured_image.url) {
                            imageUrl = matchingVariant.featured_image.url.replace('200x200', '800x800');
                        }
                        if (imageUrl) {
                            mainImage.src = imageUrl;
                        }
                    }
                    
                    // Update floating CTA
                    updateFloatingCta();
                }
            });
        });
    }
    
    // Money formatting function using Shopify's format with proper locale support
    function formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        const amountWithComma = amount.replace('.', ',');
        const amountNoDecimals = (cents / 100).toFixed(0);
        const amountNoDecimalsWithComma = amountNoDecimals.replace('.', ',');
        
        let formattedAmount = shopSettings.moneyFormat;
        
        // Handle all possible Shopify money format placeholders
        formattedAmount = formattedAmount.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithComma);
        formattedAmount = formattedAmount.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma);
        formattedAmount = formattedAmount.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals);
        formattedAmount = formattedAmount.replace(/\{\{\s*amount\s*\}\}/g, amount);
        
        // Remove any remaining cents patterns to match liquid formatting
        formattedAmount = formattedAmount.replace(/,00/g, '').replace(/\.00/g, '');
        
        return formattedAmount;
    }

    // Initialize option selection
    handleOptionSelection();



    // Handle accordion functionality
	const accordionHeaders = document.querySelectorAll('.accordion-header');
	if(accordionHeaders.length) {
		accordionHeaders.forEach(header => {
			header.addEventListener('click', function() {
				const accordionItem = this.closest('.accordion-item');
				const accordionContent = accordionItem.querySelector('.accordion-content');
				const isExpanded = this.getAttribute('aria-expanded') === 'true';
				
				// Toggle current accordion
				this.setAttribute('aria-expanded', !isExpanded);
				accordionContent.classList.toggle('active', !isExpanded);
				
				// Rotate icon
				const icon = this.querySelector('.accordion-icon');
				if (icon) {
					icon.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(315deg)';
				}
				
				accordionHeaders.forEach(otherHeader => {
			if (otherHeader !== this) {
					const otherItem = otherHeader.closest('.accordion-item');
					const otherContent = otherItem.querySelector('.accordion-content');
					const otherIcon = otherHeader.querySelector('.accordion-icon');
						
						otherHeader.setAttribute('aria-expanded', 'false');
						otherContent.classList.remove('active');
						if (otherIcon) otherIcon.style.transform = 'rotate(0deg)';
					}
				});
			});
		});
	}

    if (!productForm || !floatingCta) return;

    // Cache DOM elements
    const elements = {
        floatingCtaVariants: document.querySelector('.floating-product-cta-variant.has-variants'),
        floatingCtaVariantSelect: document.querySelector('.floating-product-cta-variant-select'),
        floatingCtaVariantButtons: document.querySelectorAll('.floating-product-cta-variant-select button'),
        hiddenInput: productForm.querySelector('input[name="id"]'),
        quantityInput: productForm.querySelector('input[name="quantity"]'),
        variantText: document.querySelector('.floating-product-text .variant span'),
        quantityText: document.querySelector('.floating-product-text .variant i'),
        floatingImage: document.querySelector('.floating-product-image')
    };

	// review carousel
	const reviewGroup = document.querySelectorAll('.block-review-group');
	if (reviewGroup.length){
		
		reviewGroup.forEach(group => {
			const reviews = group.querySelectorAll('.block-review');
			if (reviews.length > 0) {
				reviews[0].classList.add('active');
			}
			let current = 0; setInterval(() => {
				reviews[current].classList.remove('active');
				current = (current + 1) % reviews.length;
				reviews[current].classList.add('active');
			}, 4000);
		});
	}


    // Update floating CTA based on current form state
    function updateFloatingCta() {
        if (!elements.floatingCtaVariants) return;

		const currentVariantId = elements.hiddenInput?.value;
		const currentQuantity = elements.quantityInput?.value || 1;

		// Update quantity display
		if (elements.quantityText) {
			elements.quantityText.textContent = currentQuantity;
		}

		// Find and update variant info based on current ID
		if (currentVariantId && productData?.variants) {
			const currentVariant = productData.variants.find(v => v.id == currentVariantId);
			
			if (currentVariant) {
				// Update variant title
				if (elements.variantText) {
					elements.variantText.textContent = currentVariant.title;
				}

				// Update variant image - FIX: Use the image URL, not the object
				if (elements.floatingImage && currentVariant.featured_image) {
					// Check if it's already a URL or needs to be processed
					if (typeof currentVariant.featured_image === 'string') {
						elements.floatingImage.src = currentVariant.featured_image;
					} else if (currentVariant.featured_image.url) {
						elements.floatingImage.src = currentVariant.featured_image.url;
					} else {
						// Fallback to product featured image
						elements.floatingImage.src = productData.featured_image || '';
					}
				}

				// Update option selection to match current variant
				const optionGroups = document.querySelectorAll('.option-group');
				optionGroups.forEach((group, index) => {
					const optionValue = currentVariant.options[index];
					const optionRadio = group.querySelector(`input[data-value="${optionValue}"]`);
					if (optionRadio && !optionRadio.checked) {
						optionRadio.checked = true;
					}
				});
			}
		}
    }

    // Set up floating CTA variant selection
    if (elements.floatingCtaVariants) {
        // Initial update
        updateFloatingCta();

        // Toggle variant selector
        elements.floatingCtaVariants.addEventListener('click', function() {
            elements.floatingCtaVariantSelect?.classList.toggle('visible');
        });

        // Handle variant button clicks
        elements.floatingCtaVariantButtons.forEach(button => {
            button.addEventListener('click', function() {
                const variantId = this.value;
                const variantTitle = this.querySelector('span')?.textContent;
                const variantImage = this.querySelector('.floating-product-variant-image');

                // Update hidden input
                if (elements.hiddenInput) {
                    elements.hiddenInput.value = variantId;
                }

                // Update displays
                if (elements.variantText && variantTitle) {
                    elements.variantText.textContent = variantTitle;
                }

                if (elements.floatingImage && variantImage) {
                    elements.floatingImage.src = variantImage.src;
                }

                // Update option selections to match this variant
                const selectedVariant = productData.variants.find(v => v.id == variantId);
                if (selectedVariant) {
                    const optionGroups = document.querySelectorAll('.option-group');
                    optionGroups.forEach((group, index) => {
                        const optionValue = selectedVariant.options[index];
                        const optionRadio = group.querySelector(`input[data-value="${optionValue}"]`);
                        if (optionRadio) {
                            optionRadio.checked = true;
                        }
                    });
                }

                // Close selector
                elements.floatingCtaVariantSelect?.classList.remove('visible');

                // Trigger change event for option selectors
                const firstOptionSelector = document.querySelector('.option-selector:checked');
                if (firstOptionSelector) {
                    firstOptionSelector.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });

        // Watch for external changes to hidden inputs (for your app)
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    updateFloatingCta();
                }
            });
        });

        // Observe both hidden inputs for changes
        if (elements.hiddenInput) {
            observer.observe(elements.hiddenInput, { attributes: true, attributeFilter: ['value'] });
        }
        if (elements.quantityInput) {
            observer.observe(elements.quantityInput, { attributes: true, attributeFilter: ['value'] });
        }

        // Also listen for input events as backup
        if (elements.hiddenInput) {
            elements.hiddenInput.addEventListener('change', updateFloatingCta);
        }
        if (elements.quantityInput) {
            elements.quantityInput.addEventListener('change', updateFloatingCta);
        }
    }

    // Intersection observers for showing/hiding floating CTA
    function setupIntersectionObserver(targetElement, threshold = 0) {
        if (!targetElement) return null;

        return new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    floatingCta.classList.remove('visible');
                } else {
                    updateFloatingCta();
                    floatingCta.classList.add('visible');
                }
            });
        }, { threshold });
    }

    // Set up observers
    if (productDetails) {
        const productObserver = setupIntersectionObserver(productDetails);
        productObserver?.observe(productDetails);
    }

    if (siteFooter) {
        const footerObserver = setupIntersectionObserver(siteFooter);
        footerObserver?.observe(siteFooter);
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  const previewButtons = document.querySelectorAll('.video-gallery-preview');
  const videoTarget = document.querySelector('.video-gallery-selected');

  if (!previewButtons.length || !videoTarget) return;

  previewButtons.forEach((button) => {
    button.addEventListener('click', function () {
      	const videoHTML = this.dataset.videoHtml;
 
   	if (videoHTML) {
    	videoTarget.innerHTML = videoHTML;
    	const offset = -200;
    	const targetPosition = videoTarget.getBoundingClientRect().top + window.pageYOffset + offset;
    	window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }
    });
});

 // Load first video without scrolling
 const first = previewButtons[0];
  	if (first) {
  const videoHTML = first.dataset.videoHtml;
  if (videoHTML) {
  	videoTarget.innerHTML = videoHTML;
  }
 }

 // If only one video, hide the preview list
 if (previewButtons.length <= 1) {
	const previewList = document.querySelector('.video-gallery-preview-list');
	if (previewList) {
		previewList.style.display = 'none';
	}
	videoTarget.style.display = 'block';
} else {
	videoTarget.style.display = 'none';
}
});


  } catch(e) { console.error(e); }
})();
})();
